var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookshelfBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 187,
    viewBox: "0 0 452 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M442 11C447.523 11 452 15.4772 452 21L452 187L408 187L408 21C408 15.4772 412.477 11 418 11L442 11Z",
    fill: "#593122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216 11C221.523 11 226 15.4772 226 21L226 187L182 187L182 21C182 15.4772 186.477 11 192 11L216 11Z",
    fill: "#593122"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M398 19C403.523 19 408 23.4772 408 29L408 187L374 187L374 29C374 23.4772 378.477 19 384 19L398 19Z",
    fill: "#A6633C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172 19C177.523 19 182 23.4772 182 29L182 187L148 187L148 29C148 23.4772 152.477 19 158 19L172 19Z",
    fill: "#A6633C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M364 -4.37114e-07C369.523 -1.95703e-07 374 4.47715 374 10L374 187L341 187L341 9.99999C341 4.47715 345.477 -1.24677e-06 351 -1.00536e-06L364 -4.37114e-07Z",
    fill: "#D99559"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138 -4.37114e-07C143.523 -1.95703e-07 148 4.47715 148 10L148 187L115 187L115 9.99999C115 4.47715 119.477 -1.24677e-06 125 -1.00536e-06L138 -4.37114e-07Z",
    fill: "#D99559"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M331 19C336.523 19 341 23.4772 341 29L341 187L292 187L292 29C292 23.4772 296.477 19 302 19L331 19Z",
    fill: "#593122"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105 19C110.523 19 115 23.4772 115 29L115 187L66 187L66 29C66 23.4772 70.4772 19 76 19L105 19Z",
    fill: "#593122"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M282 11C287.523 11 292 15.4772 292 21L292 187L244 187L244 21C244 15.4772 248.477 11 254 11L282 11Z",
    fill: "#A6633C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56 11C61.5229 11 66 15.4772 66 21L66 187L18 187L18 21C18 15.4772 22.4772 11 28 11L56 11Z",
    fill: "#A6633C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M235 -3.93402e-07C239.971 -1.76132e-07 244 4.02944 244 9L244 187L226 187L226 9C226 4.02944 230.029 -6.10672e-07 235 -3.93402e-07Z",
    fill: "#D99559"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9 -3.93402e-07C13.9706 -1.76132e-07 18 4.02944 18 9L18 187L-5.44635e-07 187L7.23599e-06 9C7.45326e-06 4.02944 4.02944 -6.10672e-07 9 -3.93402e-07Z",
    fill: "#D99559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookshelfBooks);
export default __webpack_public_path__ + "static/media/bookshelfBooks.4d624b7dfd07dc9c5e38dfcb6ebd5cee.svg";
export { ForwardRef as ReactComponent };